import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { NetDepositLimit } from './NetDepositLimit/NetDepositLimit';
import { DepositLimitDashboardType } from 'src/components/DepositLimitTab/NetDepositLimit/NetDepositLimit.state';

interface DepositLimitTabPropsType {
    label: string;
    dashboard: DepositLimitDashboardType;
    customerId: number;
    permissionDepositLimits: boolean;
    currency: CurrencyType;
}

export const DepositLimitTab = observer(
    'DepositLimitTab',
    ({ customerId, permissionDepositLimits, currency, dashboard }: DepositLimitTabPropsType) => {
        return (
            <div>
                <NetDepositLimit
                    currency={currency}
                    customerId={customerId}
                    permissionDepositLimits={permissionDepositLimits}
                    dashboard={dashboard}
                />
            </div>
        );
    }
);
